import {
  SR_API_ACTION_PROPERTY_ATTRIBUTE_GET_BY_LISTING_ID,
} from 'api/actionTypes';

export default async function getPropertyAttributeListByListingId({ state, apiClient }, { listingId }) {
  const statePath = ['propertyAttributes', 'listByListingId', listingId];
  if (state.get(statePath)) {
    return state.get(statePath);
  }

  return apiClient.postWithState({
    action: SR_API_ACTION_PROPERTY_ATTRIBUTE_GET_BY_LISTING_ID,
    state: state,
    payload: {
      listingId,
    },
    onSuccess(propertyAttributes) {
      state.set(statePath, propertyAttributes);
    },
  });
}
